import { Link, useLocation, useNavigate } from "react-router-dom";

const AuthNavbar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const goLogin = (e) => { e.preventDefault(); navigate("/auth/login"); };
  const goRegister = (e) => { e.preventDefault(); navigate("/auth/register"); };

  return (
    <nav
      style={{
        position: "absolute",
        top: 0, left: 0, right: 0,
        padding: "20px 32px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        zIndex: 10,
      }}
    >
      <Link to="/" style={{ textDecoration: "none", display: "inline-flex", alignItems: "center", gap: 10 }}>
        <span
          style={{
            width: 36, height: 36,
            borderRadius: 10,
            background: "linear-gradient(135deg, #4F46E5, #7F77DD)",
            display: "inline-flex", alignItems: "center", justifyContent: "center",
            fontFamily: "var(--font-display)",
            fontWeight: 800, fontSize: 15, color: "#fff",
            boxShadow: "0 6px 18px rgba(79,70,229,0.45)",
          }}
        >
          S
        </span>
        <span
          style={{
            fontFamily: "var(--font-display)",
            fontWeight: 800, fontSize: 20,
            color: "#fff", letterSpacing: "-0.02em",
          }}
        >
          STOCK<span style={{ color: "#7F77DD" }}>POS</span>
        </span>
      </Link>

      <div style={{ display: "inline-flex", gap: 10 }}>
        {location.pathname !== "/auth/login" && (
          <a href="/auth/login" onClick={goLogin} className="btn-pm btn-pm--inverse btn-pm--sm">
            Login
          </a>
        )}
        {location.pathname !== "/auth/register" && (
          <a href="/auth/register" onClick={goRegister} className="btn-pm btn-pm--primary btn-pm--sm">
            Get started
          </a>
        )}
      </div>
    </nav>
  );
};

export default AuthNavbar;
